import gql from "graphql-tag";

export const SET_SEEN_NOTIFICATION = gql`
  mutation update_notification_logs_by_pk(
    $notification_id: uuid!
    $seen_at: timestamp
  ) {
    update_notification_logs_by_pk(
      pk_columns: { id: $notification_id }
      _set: { seen_at: $seen_at }
    ) {
      id
    }
  }
`;
